import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { colors } from '../../styles/vars/colors.style'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'
import { RichTextMain } from '../RichTextPlain/index.style'
import { TextBody } from '../../styles/vars/textStyles.style'

export const Image = styled.div`
  border-radius: 0.6rem;
  overflow: hidden;
`

export const Details = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  ${mq.tabletL} {
    align-content: center;
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: space-between;

    ${({ toggle }) => toggle && `justify-content: flex-end;`}
  }
`

export const Toggle = styled.div`
  border: 0.1rem solid ${colors.dark};
  border-radius: 50%;
  display: inline-block;
  height: 1.6rem;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 1.5s ${easings.out.quart},
    opacity 1.4s ${easings.out.quart};
  transition-delay: ${props => props.delay}s;
  width: 1.6rem;

  ${mq.tabletL} {
    position: relative;
    top: auto;
    transform: translateY(0%);
  }

  ${({ isOpen }) => {
    return isOpen === false
      ? `&:before {
        transform: scale(0.2);
      }`
      : `&:before {
        transform: scale(1);
      }`
  }}

  &:before {
    background-color: ${colors.dark};
    border-radius: 50%;
    content: '';
    height: 1.4rem;
    left: 0;
    position: absolute;
    top: 0;
    transform-origin: center center;
    transition: transform 0.6s ${easings.inOut.quart};
    width: 1.4rem;
  }
`

export const AccordionTitle = styled.button`
  appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;

  ${mq.tabletL} {
    width: 100%;
  }
`

export const AccordionItemLine = styled.span`
  background-color: rgba(43, 44, 62, 0.2);
  bottom: 0;
  height: 0.1rem;
  left: 0;
  position: absolute;
  right: 0;
  transform-origin: 0% 0%;

  &:after {
    background-color: ${colors.darkBlue};
    bottom: 0;
    content: '';
    left: 0;
    opacity: ${props => (props.isOpen ? `0.4` : `.8`)};
    position: absolute;
    right: 0;
    top: 0;
    transform: scaleX(${props => (props.isOpen ? `1` : `0`)});
    transform-origin: 0% 0%;
    transition: transform 1.5s ${easings.out.quart},
      opacity 1.4s ${easings.out.quart};
    z-index: 2;
  }
`

export const AccordionItem = styled.li`
  cursor: pointer;
  position: relative;

  ${mq.desk} {
    &:hover {
      ${AccordionItemLine}:after {
        opacity: 0.4;
        transform: scaleX(1);
      }
    }
  }

  :not(:first-of-type) {
    padding-top: 3rem;
  }
`

export const AccordionInner = styled.div`
  display: block;
`

export const DescOuter = styled.div.attrs(props => ({
  style: {
    maxHeight: `${props.maxHeight}px`,
  },
}))`
  overflow: hidden;
  padding-bottom: 0rem;
  transition: max-height 0.6s ${easings.inOut.quart};
`

export const Desc = styled.div`
  ${RichTextMain} {
    padding-bottom: 2rem;
  }
  ${TextBody} {
    ${clamp('font-size', 14, 18)};
  }
`
